"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Response = void 0;
var Headers_1 = require("../../../shared/internal/HTTPRequestConfig/Headers");
var Response = /** @class */ (function () {
    function Response(params) {
        var rawHeaders = params.rawHeaders, reqConfig = params.reqConfig, responseData = params.responseData;
        this.requestBody = '';
        this.requestURI = reqConfig.uri;
        this.requestHeaders = reqConfig.headers;
        this.requestMethod = reqConfig.method;
        this.responseHeaders = new Headers_1.Headers((typeof rawHeaders === 'string' ? parseResponseHeaders(rawHeaders) : Array.from(rawHeaders.entries())) || []);
        this.responseBody = responseData;
        this.responseStatusCode = params.statusCode;
    }
    Response.prototype.complete = function () {
        return {
            requestURI: this.requestURI,
            requestMethod: this.requestMethod,
            requestHeaders: this.requestHeaders.toArray(),
            requestBody: this.requestBody,
            responseStatusCode: this.responseStatusCode,
            responseHeaders: this.responseHeaders.toArray(),
            responseBody: this.responseBody,
        };
    };
    return Response;
}());
exports.Response = Response;
var withoutEmpty = function (header) { return header.trim().length > 0; };
var nameWithValue = function (header) {
    var index = header.indexOf(':');
    return [header.slice(0, index).trim().toLowerCase(), header.slice(index + 1).trim()];
};
function parseResponseHeaders(str) {
    return str.split('\r\n').filter(withoutEmpty).map(nameWithValue);
}
//# sourceMappingURL=Response.js.map